module.exports = __webpack_public_path__ + "img/login_bg.e6ce102.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/login_bg.jpg
// module id = 530
// module chunks = 2